
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1qkal_1rsnr_15",
  "avatar-color-default": "awsui_avatar-color-default_1qkal_1rsnr_50",
  "avatar-color-gen-ai": "awsui_avatar-color-gen-ai_1qkal_1rsnr_53",
  "initials": "awsui_initials_1qkal_1rsnr_56",
  "image": "awsui_image_1qkal_1rsnr_83",
  "content": "awsui_content_1qkal_1rsnr_87"
};
  